import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { formatNumByRegion } from '../util';
import { $Locale } from '../atom';
export const useNumFormatter = () => {
    const { region } = useAtomValue($Locale);
    const { t } = useTranslation();
    return useCallback((num) => formatNumByRegion(num, region, t), []);
};
